/* D'Evin mağaza teması — küçük davranış katmanı (framework yok).
   1) Header: yapışkan barın "yapıştı" durumu (IntersectionObserver, scroll
      dinleyicisi yok), açılır alt menüler (tıklama birincil; hover yalnız
      ince işaretçide, 400/500 ms), mobil çekmece (tek modal yüzey: kaydırma
      kilidi, Esc, odak kapsama, arkaya inert).
   2) Banner: kaydırma-kilitli slayt (scroll-snap), oklar, noktalar, isteğe
      bağlı otomatik geçiş (hareketi azalt tercihinde kapalı; imleç/odak
      üstündeyken durur).
   3) Showroom bandı: iki açılır panel (aria-expanded/aria-controls, Esc).
   Kurumsal sitedeki Header.tsx / ShowroomPanels.tsx sözleşmesinin sade
   karşılığı; davranış render'dan ölçülerek doğrulanır. */
(function () {
  'use strict';
  /* K-190: görünen metinler dil dosyasından (theme.liquid `window.devinMetin`).
     İkinci argüman Türkçe yedektir: nesne ya da anahtar yoksa eski davranış sürer. */
  var METIN = window.devinMetin || {};
  function m(ad, yedek) {
    return typeof METIN[ad] === 'string' && METIN[ad] !== '' ? METIN[ad] : yedek;
  }
  var azHareket = window.matchMedia('(prefers-reduced-motion: reduce)');
  var inceIsaretci = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------------- header ---------------- */
  function header() {
    var kok = document.querySelector('[data-devin-header]');
    if (!kok) return;
    var bar = kok.querySelector('[data-yapiskan]');
    var nobetci = kok.querySelector('[data-nobetci]');
    if (bar && nobetci && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (girdiler) {
          bar.classList.toggle('yapisti', !girdiler[0].isIntersecting);
        },
        { rootMargin: '-1px 0px 0px 0px' }
      ).observe(nobetci);
    }

    /* açılır alt menüler */
    var acik = null;
    var sayac = null;
    var tetikler = kok.querySelectorAll('[data-alt-menu]');
    function temizle() {
      if (sayac) clearTimeout(sayac);
      sayac = null;
    }
    function kapat() {
      temizle();
      if (!acik) return;
      acik.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(acik.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
      acik = null;
    }
    function ac(dugme) {
      temizle();
      if (acik && acik !== dugme) kapat();
      dugme.setAttribute('aria-expanded', 'true');
      var panel = document.getElementById(dugme.getAttribute('aria-controls'));
      if (panel) panel.hidden = false;
      acik = dugme;
    }
    Array.prototype.forEach.call(tetikler, function (dugme) {
      var li = dugme.parentNode;
      dugme.addEventListener('click', function () {
        if (acik === dugme) kapat();
        else ac(dugme);
      });
      li.addEventListener('mouseenter', function () {
        if (!inceIsaretci.matches) return;
        temizle();
        if (acik) ac(dugme);
        else sayac = setTimeout(function () { ac(dugme); }, 400);
      });
      li.addEventListener('mouseleave', function () {
        if (!inceIsaretci.matches) return;
        temizle();
        sayac = setTimeout(kapat, 500);
      });
      li.addEventListener('focusout', function (e) {
        if (acik !== dugme) return;
        if (li.contains(e.relatedTarget)) return;
        kapat();
      });
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && acik) {
        var d = acik;
        kapat();
        d.focus();
      }
    });
    window.addEventListener('pointerdown', function (e) {
      if (acik && !kok.contains(e.target)) kapat();
    });
    window.addEventListener('resize', kapat);

    /* dil seçici (K-206): ince işaretçide imleçle açılır (CSS), tıklama ve klavye burada.
       İmleç çekilince, dışarı dokununca, odak çıkınca ve Esc ile kapanır. */
    var dil = kok.querySelector('.dil');
    var dilDugme = dil ? dil.querySelector('.dil__dugme') : null;
    if (dil && dilDugme) {
      var dilAyarla = function (acikMi) {
        dil.classList.toggle('dil--acik', acikMi);
        dilDugme.setAttribute('aria-expanded', acikMi ? 'true' : 'false');
      };
      dil.classList.add('dil--js');
      dilDugme.addEventListener('click', function (e) {
        /* fareyle tıklamada liste zaten imleçle açıktır: kapatmak görünürde bir şey değiştirmez.
           Klavye (detail 0) ve dokunmada aç/kapa. */
        var fare = e.detail > 0 && inceIsaretci.matches;
        dilAyarla(fare ? true : !dil.classList.contains('dil--acik'));
      });
      dil.addEventListener('mouseenter', function () {
        if (inceIsaretci.matches) dilDugme.setAttribute('aria-expanded', 'true');
      });
      dil.addEventListener('mouseleave', function () {
        if (inceIsaretci.matches) dilAyarla(false);
      });
      dil.addEventListener('focusout', function (e) {
        if (!dil.contains(e.relatedTarget)) dilAyarla(false);
      });
      dil.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !dil.classList.contains('dil--acik')) return;
        dilAyarla(false);
        dilDugme.focus();
      });
      window.addEventListener('pointerdown', function (e) {
        if (!dil.contains(e.target)) dilAyarla(false);
      });
    }

    /* mobil çekmece */
    var cekmece = kok.querySelector('[data-cekmece]');
    var acDugme = kok.querySelector('[data-cekmece-ac]');
    var kapatDugme = kok.querySelector('[data-cekmece-kapat]');
    if (!cekmece || !acDugme) return;
    var arka = [document.querySelector('main'), document.querySelector('footer')];
    function cekmeceKapat() {
      cekmece.hidden = true;
      document.documentElement.style.overflow = '';
      acDugme.setAttribute('aria-expanded', 'false');
      arka.forEach(function (el) { if (el) el.removeAttribute('inert'); });
      acDugme.focus();
    }
    function cekmeceAc() {
      cekmece.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      acDugme.setAttribute('aria-expanded', 'true');
      arka.forEach(function (el) { if (el) el.setAttribute('inert', ''); });
      (kapatDugme || cekmece).focus();
    }
    acDugme.addEventListener('click', cekmeceAc);
    if (kapatDugme) kapatDugme.addEventListener('click', cekmeceKapat);
    cekmece.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cekmeceKapat(); return; }
      if (e.key !== 'Tab') return;
      var odaklar = cekmece.querySelectorAll('a[href], button:not([disabled])');
      if (!odaklar.length) return;
      var ilk = odaklar[0];
      var son = odaklar[odaklar.length - 1];
      if (e.shiftKey && (document.activeElement === ilk || document.activeElement === cekmece)) { e.preventDefault(); son.focus(); }
      else if (!e.shiftKey && document.activeElement === son) { e.preventDefault(); ilk.focus(); }
    });
    window.matchMedia('(min-width: 1024px)').addEventListener('change', function (mq) {
      if (mq.matches && !cekmece.hidden) cekmeceKapat();
    });
  }

  /* ---------------- banner ---------------- */
  function banner() {
    var kokler = document.querySelectorAll('[data-devin-banner]');
    Array.prototype.forEach.call(kokler, function (kok) {
      var ray = kok.querySelector('[data-ray]');
      var slaytlar = ray ? ray.children : [];
      if (!ray || slaytlar.length < 2) return;
      var onceki = kok.querySelector('[data-onceki]');
      var sonraki = kok.querySelector('[data-sonraki]');
      var noktalar = kok.querySelectorAll('[data-nokta]');
      var sure = parseInt(kok.getAttribute('data-sure') || '0', 10) * 1000;
      var aktif = 0;
      var zaman = null;
      var durdu = false;

      function git(i, anlik) {
        var n = slaytlar.length;
        i = ((i % n) + n) % n;
        ray.scrollTo({ left: slaytlar[i].offsetLeft, behavior: anlik || azHareket.matches ? 'auto' : 'smooth' });
      }
      function isaretle() {
        var w = ray.clientWidth || 1;
        var i = Math.round(ray.scrollLeft / w);
        if (i === aktif) return;
        aktif = Math.max(0, Math.min(slaytlar.length - 1, i));
        Array.prototype.forEach.call(noktalar, function (n, k) {
          n.setAttribute('aria-current', k === aktif ? 'true' : 'false');
        });
        Array.prototype.forEach.call(slaytlar, function (s, k) {
          s.setAttribute('aria-hidden', k === aktif ? 'false' : 'true');
        });
      }
      ray.addEventListener('scroll', function () { window.requestAnimationFrame(isaretle); }, { passive: true });
      if (onceki) onceki.addEventListener('click', function () { git(aktif - 1); yenidenBasla(); });
      if (sonraki) sonraki.addEventListener('click', function () { git(aktif + 1); yenidenBasla(); });
      Array.prototype.forEach.call(noktalar, function (n, k) {
        n.addEventListener('click', function () { git(k); yenidenBasla(); });
      });

      function dur() { if (zaman) clearInterval(zaman); zaman = null; }
      function basla() {
        if (!sure || azHareket.matches || durdu) return;
        dur();
        zaman = setInterval(function () {
          if (document.hidden) return;
          git(aktif + 1);
        }, sure);
      }
      function yenidenBasla() { dur(); basla(); }
      kok.addEventListener('mouseenter', function () { durdu = true; dur(); });
      kok.addEventListener('mouseleave', function () { durdu = false; basla(); });
      kok.addEventListener('focusin', function () { durdu = true; dur(); });
      kok.addEventListener('focusout', function (e) {
        if (kok.contains(e.relatedTarget)) return;
        durdu = false;
        basla();
      });
      ray.addEventListener('touchstart', function () { durdu = true; dur(); }, { passive: true });
      ray.addEventListener('touchend', function () { durdu = false; basla(); }, { passive: true });
      isaretle();
      basla();
      window.addEventListener('resize', function () { git(aktif, true); });
      /* sonraki slaytların görselleri sayfa yüklendikten sonra çekilir:
         otomatik geçiş boş kareye düşmesin, ilk yük de ağırlaşmasın */
      function onYukle() {
        Array.prototype.forEach.call(ray.querySelectorAll('img[loading="lazy"]'), function (img) {
          img.loading = 'eager';
        });
      }
      if (document.readyState === 'complete') onYukle();
      else window.addEventListener('load', onYukle, { once: true });
    });
  }

  /* ---------------- ürün karuseli ---------------- */
  function karusel() {
    var kokler = document.querySelectorAll('[data-devin-karusel]');
    Array.prototype.forEach.call(kokler, function (kok) {
      var ray = kok.querySelector('[data-ray]');
      var onceki = kok.querySelector('[data-onceki]');
      var sonraki = kok.querySelector('[data-sonraki]');
      if (!ray || !onceki || !sonraki) return;
      function durum() {
        var son = ray.scrollWidth - ray.clientWidth - 2;
        onceki.setAttribute('aria-disabled', ray.scrollLeft <= 2 ? 'true' : 'false');
        sonraki.setAttribute('aria-disabled', ray.scrollLeft >= son ? 'true' : 'false');
      }
      function kaydir(yon) {
        ray.scrollBy({ left: yon * ray.clientWidth * 0.9, behavior: azHareket.matches ? 'auto' : 'smooth' });
      }
      onceki.addEventListener('click', function () { kaydir(-1); });
      sonraki.addEventListener('click', function () { kaydir(1); });
      ray.addEventListener('scroll', function () { window.requestAnimationFrame(durum); }, { passive: true });
      window.addEventListener('resize', durum);
      durum();
    });
  }

  /* ---------------- showroom panelleri ---------------- */
  function showroom() {
    var kokler = document.querySelectorAll('[data-devin-showroom]');
    Array.prototype.forEach.call(kokler, function (kok) {
      var dugmeler = kok.querySelectorAll('[data-panel-dugme]');
      function kapatHepsi(haric) {
        Array.prototype.forEach.call(dugmeler, function (d) {
          if (d === haric) return;
          d.setAttribute('aria-expanded', 'false');
          var p = document.getElementById(d.getAttribute('aria-controls'));
          if (p) p.hidden = true;
        });
      }
      Array.prototype.forEach.call(dugmeler, function (d) {
        d.addEventListener('click', function () {
          var acikMi = d.getAttribute('aria-expanded') === 'true';
          kapatHepsi(d);
          d.setAttribute('aria-expanded', acikMi ? 'false' : 'true');
          var p = document.getElementById(d.getAttribute('aria-controls'));
          if (p) p.hidden = acikMi;
        });
      });
      kok.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') kapatHepsi(null);
      });
    });
  }

  /* ---------------- sepet sayacı (K-127) ----------------
     Header'daki üç rozet (üst şerit, mobil düğme, yapışkan bar) sunucudan
     basılır; sepete AJAX ile ekleyince burada güncellenir. */
  function sepetSayisi(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sepet-adet]'), function (el) {
      el.textContent = n > 0 ? ' (' + n + ')' : '';
    });
    var hedefler = [
      { kap: '.ust__sepet', sinif: 'ust__sayi' },
      { kap: '.ust__mobil-dugme[href*="cart"]', sinif: 'ust__sayi ust__sayi--mobil' },
      { kap: '.bar__ikon[href*="cart"]', sinif: 'bar__sayi' }
    ];
    hedefler.forEach(function (h) {
      Array.prototype.forEach.call(document.querySelectorAll(h.kap), function (kap) {
        var rozet = kap.querySelector('.' + h.sinif.split(' ')[0]);
        if (n > 0) {
          if (!rozet) {
            rozet = document.createElement('span');
            rozet.className = h.sinif;
            rozet.setAttribute('aria-hidden', 'true');
            kap.appendChild(rozet);
          }
          rozet.textContent = n;
        } else if (rozet) {
          rozet.parentNode.removeChild(rozet);
        }
        kap.setAttribute('aria-label', m('sepet', 'Sepet') + (n > 0 ? ', ' + n + ' ' + (n === 1 ? m('urunBir', 'ürün') : m('urunCok', 'ürün')) : ''));
      });
    });
  }

  /* fiyat biçimi — devin-fiyat.liquid ile BİREBİR olmalı.
     4894100 → "48.941 ₺" · 2757240 → "27.572,40 ₺"

     K-157 (14 Eyl): eskiden `Math.round(kurus / 100)` idi ve kuruşu yutuyordu.
     Liquid tarafı K-154'te düzeltilmişti ama bu ikiz atlanmıştı; yorumunda
     "birebir" yazdığı halde değildi. Yuvarlama ayrıca YUKARI da çıkabiliyordu
     (169077.60 → "169.078 ₺"), yani ödenecek tutardan FAZLA gösterebiliyordu.
     Varyant değişiminde basılan fiyat buradan geliyor; 40 aktif ürünün 15'i
     kuruşlu. */
  function fiyat(kurus) {
    var tam = Math.floor(kurus / 100);
    var ondalik = kurus % 100;
    var s = String(tam).replace(/\B(?=(\d{3})+(?!\d))/g, m('fiyatBinlik', '.'));
    if (ondalik !== 0) s += m('fiyatOndalik', ',') + (ondalik < 10 ? '0' : '') + ondalik;
    /* kalıp dile göre: Türkçe "[tutar] ₺", İngilizce "₺[tutar]" (devin-fiyat.liquid ile aynı anahtar) */
    return m('fiyatBicim', '[tutar] ₺').split('[tutar]').join(s);
  }

  /* ---------------- ürün sayfası (K-127) ---------------- */
  function urun() {
    var kok = document.querySelector('[data-urun]');
    if (!kok) return;
    var sepetUrl = kok.getAttribute('data-sepet') || '/cart';
    var ekleUrl = kok.getAttribute('data-ekle-url') || '/cart/add';

    /* galeri: küçük resim → sahne */
    var kareler = kok.querySelectorAll('[data-kare]');
    var kucukler = kok.querySelectorAll('[data-kucuk]');
    var aktif = 0;
    function goster(i) {
      aktif = i;
      Array.prototype.forEach.call(kareler, function (k, j) { k.hidden = j !== i; });
      Array.prototype.forEach.call(kucukler, function (b, j) {
        if (j === i) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }
    Array.prototype.forEach.call(kucukler, function (b, i) {
      b.addEventListener('click', function () { goster(i); });
    });

    /* yakınlaştırma: native dialog, 1×/2×, kaydırarak gezme (kurumsal PieceGallery) */
    var dialog = kok.querySelector('[data-zoom-dialog]');
    var zoomAc = kok.querySelector('[data-zoom-ac]');
    if (dialog && zoomAc && typeof dialog.showModal === 'function') {
      var zoomImg = dialog.querySelector('[data-zoom-img]');
      var buyut = dialog.querySelector('[data-zoom-buyut]');
      var alan = dialog.querySelector('[data-zoom-alan]');
      zoomAc.addEventListener('click', function () {
        var kare = kareler[aktif];
        var kaynak = kare ? kare.getAttribute('data-buyuk') : null;
        if (kaynak && zoomImg.getAttribute('src') !== kaynak) zoomImg.src = kaynak;
        dialog.classList.remove('zoom--buyuk');
        buyut.setAttribute('aria-pressed', 'false');
        dialog.showModal();
        if (alan) alan.focus();
      });
      buyut.addEventListener('click', function () {
        var b = dialog.classList.toggle('zoom--buyuk');
        buyut.setAttribute('aria-pressed', b ? 'true' : 'false');
      });
      var kapat = dialog.querySelector('[data-zoom-kapat]');
      if (kapat) kapat.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }

    /* varyant seçimi → fiyat, stok, kimlik, adres */
    var form = kok.querySelector('#urun-formu');
    var veri = kok.querySelector('[data-varyantlar]');
    var varyantlar = [];
    try { varyantlar = JSON.parse(veri ? veri.textContent : '[]'); } catch (e) { varyantlar = []; }
    var secimler = kok.querySelectorAll('[data-secenek]');
    var idAlani = kok.querySelector('[data-varyant-id]');
    var guncel = kok.querySelector('[data-guncel-fiyat]');
    var eski = kok.querySelector('[data-eski-fiyat]');
    var ekle = kok.querySelector('[data-ekle]');
    var ekleMetin = kok.querySelector('[data-ekle-metin]');

    /* adet seçici (K-148) — sepet satırındaki bileşenin aynısı.
       JS yoksa sayı alanı kendi başına çalışır; ± yalnız kolaylık. */
    var adetGirdi = kok.querySelector('[data-adet-girdi]');
    if (adetGirdi) {
      var adetKutu = kok.querySelector('[data-adet]');
      var azalt = adetKutu && adetKutu.querySelector('[data-adet-azalt]');
      var artir = adetKutu && adetKutu.querySelector('[data-adet-artir]');
      var enAz = parseInt(adetGirdi.getAttribute('min'), 10) || 1;
      function adetOku() {
        var n = parseInt(adetGirdi.value, 10);
        return isNaN(n) ? enAz : n;
      }
      function adetYaz(n) {
        var ustSinir = parseInt(adetGirdi.getAttribute('max'), 10);
        if (!isNaN(ustSinir) && n > ustSinir) n = ustSinir;
        if (n < enAz) n = enAz;
        adetGirdi.value = n;
        if (azalt) azalt.disabled = n <= enAz;
        if (artir) artir.disabled = !isNaN(ustSinir) && n >= ustSinir;
      }
      if (azalt) azalt.addEventListener('click', function () { adetYaz(adetOku() - 1); });
      if (artir) artir.addEventListener('click', function () { adetYaz(adetOku() + 1); });
      adetGirdi.addEventListener('change', function () { adetYaz(adetOku()); });
      adetYaz(adetOku());
    }
    function bul() {
      if (!secimler.length) return null;
      var secili = Array.prototype.map.call(secimler, function (s) { return s.value; });
      for (var i = 0; i < varyantlar.length; i++) {
        var v = varyantlar[i];
        var ok = true;
        for (var j = 0; j < secili.length; j++) {
          if (v.options[j] !== secili[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function uygula(v) {
      if (!ekle) return;
      if (!v) {
        ekle.disabled = true;
        ekleMetin.textContent = m('secenekYok', 'Bu seçenek yok');
        return;
      }
      if (idAlani) idAlani.value = v.id;
      if (guncel) guncel.textContent = fiyat(v.price);
      if (eski) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          eski.textContent = fiyat(v.compare_at_price);
          eski.hidden = false;
        } else {
          eski.hidden = true;
        }
      }
      ekle.disabled = !v.available;
      ekleMetin.textContent = v.available ? m('sepeteEkle', 'Sepete ekle') : m('tukendi', 'Tükendi');
      if (window.history && history.replaceState && window.URL) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u.toString());
      }
    }
    Array.prototype.forEach.call(secimler, function (s) {
      s.addEventListener('change', function () { uygula(bul()); });
    });

    /* sepete ekle — AJAX; başarısızsa doğal gönderime düşer */
    var geri = kok.querySelector('[data-geri]');
    if (form && ekle && window.fetch && window.FormData) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var oncekiMetin = ekleMetin.textContent;
        ekle.disabled = true;
        ekleMetin.textContent = m('ekleniyor', 'Ekleniyor…');
        if (geri) geri.hidden = true;
        var govde = new FormData(form);
        fetch(ekleUrl + '.js', { method: 'POST', body: govde, headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('ekle'); return r.json(); })
          .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (sepet) {
            sepetSayisi(sepet.item_count);
            if (geri) {
              geri.className = 'urun__geri';
              geri.textContent = '';
              geri.appendChild(document.createTextNode(m('eklendi', 'Sepete eklendi.') + ' '));
              var a = document.createElement('a');
              a.href = sepetUrl;
              a.textContent = m('sepeteGidin', 'Sepete gidin');
              geri.appendChild(a);
              geri.hidden = false;
            }
            ekleMetin.textContent = oncekiMetin;
            ekle.disabled = false;
          })
          .catch(function () {
            if (geri) {
              geri.className = 'urun__geri urun__geri--hata';
              geri.textContent = m('eklenemedi', 'Eklenemedi. Lütfen tekrar deneyin.');
              geri.hidden = false;
            }
            ekleMetin.textContent = oncekiMetin;
            ekle.disabled = false;
          });
      });
    }
  }

  /* ---------------- koleksiyon: sıralama seçimi (K-127) ---------------- */
  function koleksiyon() {
    var form = document.querySelector('[data-sirala]');
    if (!form) return;
    var secim = form.querySelector('select');
    if (secim) secim.addEventListener('change', function () { form.submit(); });
  }

  /* ---------------- sepet sayfası (K-128) ----------------
     Adet ± / girdi / kaldır → /cart/change.js; sonra bölüm Shopify'ın
     Section Rendering API'siyle (?section_id=) yeniden çekilip yerine
     konur — toplamlar, indirimler ve boş durum sunucudan gelir, JS'te
     ikinci bir fiyat mantığı yok. Olaylar belgeye bağlanır (delegasyon),
     bölüm değişince yeniden bağlamak gerekmez. JS yoksa form updates[]
     ile doğal gönderilir (noscript "Sepeti güncelle"). */
  function sepet() {
    if (sepet.bagli || !document.querySelector('[data-sepet-sayfa]')) return;
    sepet.bagli = true;
    var mesgul = false;
    function kok() { return document.querySelector('[data-sepet-sayfa]'); }
    function belgeBaglantilari(k) {
      var onizleme = false;
      try { onizleme = sessionStorage.getItem('devin-magaza-onizleme') === '1'; } catch (e) {}
      if (!onizleme) return;
      Array.prototype.forEach.call(k.querySelectorAll('[data-sepet-belge]'), function (a) {
        var url = new URL(a.href, window.location.href);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('onizleme', '1');
        a.href = url.toString();
      });
    }
    belgeBaglantilari(kok());
    function durum(metin) {
      var k = kok();
      var d = k && k.querySelector('[data-sepet-durum]');
      if (d) d.textContent = metin || '';
    }
    function satirHata(satir, metin) {
      var h = satir && satir.querySelector('[data-satir-hata]');
      if (!h) return;
      h.textContent = metin || '';
      h.hidden = !metin;
    }
    function mesgulYap(evet) {
      mesgul = evet;
      var k = kok();
      if (!k) return;
      k.setAttribute('aria-busy', evet ? 'true' : 'false');
      Array.prototype.forEach.call(
        k.querySelectorAll('[data-adet-azalt], [data-adet-artir], [data-adet-girdi], [data-odeme]'),
        function (el) { el.disabled = evet; }
      );
    }
    function yenile(odak, satirNo, odakSecici) {
      var k = kok();
      var url = (k.getAttribute('data-sepet-url') || '/cart') + '?section_id=' + encodeURIComponent(k.getAttribute('data-bolum-id'));
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('bolum'); return r.text(); })
        .then(function (html) {
          var yeni = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sepet-sayfa]');
          if (!yeni) throw new Error('bolum');
          var odagiKoru = odak && (document.activeElement === document.body || k.contains(document.activeElement));
          belgeBaglantilari(yeni);
          k.parentNode.replaceChild(yeni, k);
          if (odagiKoru) {
            var satirlar = yeni.querySelectorAll('[data-satir]');
            var hedefSatir = yeni.querySelector('[data-satir="' + satirNo + '"]') || satirlar[satirlar.length - 1];
            var hedef = hedefSatir && hedefSatir.querySelector(odakSecici || '[data-adet-girdi]');
            if (!hedef) hedef = yeni.querySelector('.sepet__bos-baglantilar a, .sepet__devam');
            if (hedef) hedef.focus({ preventScroll: true });
          }
        });
    }
    function degistir(satir, adet) {
      if (mesgul || !satir) return;
      var line = Number(satir.getAttribute('data-satir'));
      var girdi = satir.querySelector('[data-adet-girdi]');
      var sunucu = Number(girdi.getAttribute('data-adet-sunucu'));
      if (adet === sunucu) return;
      var odak = satir.contains(document.activeElement) ? document.activeElement : null;
      var odakSecici = '[data-adet-girdi]';
      ['data-adet-azalt', 'data-adet-artir', 'data-kaldir'].forEach(function (ad) {
        if (odak && odak.hasAttribute(ad)) odakSecici = '[' + ad + ']';
      });
      satirHata(satir, '');
      mesgulYap(true);
      durum(m('guncelleniyor', 'Sepet güncelleniyor.'));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: adet })
      })
        .then(function (r) { return r.json().then(function (veri) { return { ok: r.ok, veri: veri }; }); })
        .then(function (s) {
          if (!s.ok) {
            girdi.value = sunucu;
            satirHata(satir, m('stokYok', 'Bu üründen istenen adet stokta yok.'));
            mesgulYap(false);
            durum('');
            return;
          }
          var kalan = s.veri.items && s.veri.items[line - 1];
          var kirpildi = adet > 0 && kalan && kalan.quantity < adet;
          return yenile(odak, line, odakSecici).then(function () {
            mesgul = false;
            sepetSayisi(s.veri.item_count);
            durum(adet === 0 ? m('kaldirildi', 'Ürün sepetten kaldırıldı.') : m('guncellendi', 'Sepet güncellendi.'));
            if (kirpildi) satirHata(kok().querySelector('[data-satir="' + line + '"]'), m('stokKirpildi', 'Stokta [adet] adet var; sepet buna göre düzeltildi.').split('[adet]').join(kalan.quantity));
          });
        })
        .catch(function () {
          /* AJAX kırıldıysa doğal gönderim: sunucu sayfayı yeniden kurar */
          mesgulYap(false);
          var form = document.querySelector('[data-sepet-form]');
          if (form) form.submit();
        });
    }
    /* K-157 (14 Eyl): burada `max`a SESSİZ kırpma vardı ve kusurun kaynağıydı.
       Okurken kırpılıyor, yazarken kırpılmıyordu; görünen değer sunucudaki
       adetten ayrışıyordu. Aritmetik kırpılmış sayı üzerinden yapıldığı için
       stok tavanına dayanmış bir satırda "+" adedi DÜŞÜRÜYORDU (görünen 2,
       kırpılmış 1, +1 = 2, tekrar kırpılıp 1 gönderiliyordu) ve "−" bir adım
       atlıyordu. Kırpmayı sunucu yapar; `degistir` zaten "Stokta N adet var"
       diye bildiriyor. Burada yalnız sayı temizliği kalır. */
    function girdiAdedi(girdi) {
      var n = Math.floor(Number(girdi.value));
      if (!isFinite(n) || n < 0) n = 0;
      return n;
    }
    /* Artır/azalt DAİMA sunucunun bildiği adetten hesaplanır; girdinin o anki
       görünen değerinden değil. İkisi ayrışabilir. */
    function sunucuAdedi(girdi) {
      var n = Number(girdi.getAttribute('data-adet-sunucu'));
      return isFinite(n) && n >= 0 ? n : girdiAdedi(girdi);
    }
    document.addEventListener('click', function (e) {
      var k = kok();
      if (!k || !e.target.closest || !k.contains(e.target)) return;
      var azalt = e.target.closest('[data-adet-azalt]');
      var artir = e.target.closest('[data-adet-artir]');
      var kaldir = e.target.closest('[data-kaldir]');
      if (!azalt && !artir && !kaldir) return;
      e.preventDefault();
      if (mesgul) return;
      var satir = e.target.closest('[data-satir]');
      var girdi = satir && satir.querySelector('[data-adet-girdi]');
      if (!girdi) return;
      var temel = sunucuAdedi(girdi);
      var n;
      if (kaldir) n = 0;
      else if (azalt) n = Math.max(0, temel - 1);
      else n = temel + 1;
      girdi.value = n;
      degistir(satir, n);
    });
    document.addEventListener('change', function (e) {
      var k = kok();
      if (!k || !k.contains(e.target)) return;
      if (e.target.hasAttribute('data-adet-girdi')) {
        var satir = e.target.closest('[data-satir]');
        e.target.value = girdiAdedi(e.target);
        degistir(satir, girdiAdedi(e.target));
      } else if (e.target.hasAttribute('data-sepet-not')) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: e.target.value })
        }).then(function (r) { if (r.ok) durum(m('notKaydedildi', 'Sipariş notu kaydedildi.')); }).catch(function () {});
      }
    });
    /* Adet girdisinde Enter formu göndermesin; değişiklik olayı yeter */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.hasAttribute && e.target.hasAttribute('data-adet-girdi')) {
        e.preventDefault();
        e.target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function basla() {
    header();
    banner();
    karusel();
    showroom();
    urun();
    koleksiyon();
    sepet();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();

  /* Tema editörü bölümü yeniden yüklediğinde davranışı yeniden bağla */
  document.addEventListener('shopify:section:load', function () {
    banner();
    karusel();
    showroom();
    urun();
    koleksiyon();
    sepet();
  });
})();
